import React from 'react';
import { Pressable, TextInput, View } from 'react-native';
import { useAppStore } from '@restorant/core';
import { fontStyle, radius, scaleFont, useColors, useTextScale } from '../theme';
import { useT } from '../i18n';
import { Icon } from '../icons/Icon';

export function SearchBar({ style }: { style?: any }) {
  const colors = useColors();
  const t = useT();
  const scale = useTextScale();
  const search = useAppStore((s) => s.search);
  const setSearch = useAppStore((s) => s.setSearch);

  return (
    <View
      style={[
        {
          flexDirection: 'row',
          alignItems: 'center',
          gap: 9,
          backgroundColor: colors.surface,
          borderWidth: 1,
          borderColor: colors.line,
          borderRadius: radius.pill,
          paddingVertical: 9,
          paddingHorizontal: 14,
        },
        style,
      ]}
    >
      <Icon name="search" size={15} color={colors.textFaint} />
      <TextInput
        value={search}
        onChangeText={setSearch}
        placeholder={t('search_placeholder')}
        placeholderTextColor={colors.textFaint}
        style={[
          {
            flex: 1,
            color: colors.text,
            fontSize: scaleFont(13.5, scale),
            padding: 0,
            // react-native-web renders a real <input>; kill its focus ring.
            outlineStyle: 'none',
          } as any,
          fontStyle(500),
        ]}
      />
      {search ? (
        <Pressable onPress={() => setSearch('')} hitSlop={8}>
          <Icon name="close" size={15} color={colors.textFaint} />
        </Pressable>
      ) : null}
    </View>
  );
}
